import React from 'react';
import IconButton from '@mui/material/IconButton';
import LinkIcon from '@mui/icons-material/LinkRounded';
import ToolTip from 'core/components/Tooltip';
import {
  useNotify,
} from 'core/hooks';

// The URL already holds the panel and its state, so the link reopens the same view
export default function CopyLinkButton() {
  const notify = useNotify();

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      notify({
        variant: 'success',
        message: 'Link copied to clipboard.',
      });
    } catch {
      notify({
        variant: 'error',
        message: 'Could not copy link.',
      });
    }
  };

  return (
    <ToolTip title="Copy link">
      <IconButton
        size="small"
        aria-label="Copy link"
        onClick={onCopy}
      >
        <LinkIcon className="!w-5 !h-5 -rotate-45" />
      </IconButton>
    </ToolTip>
  );
}
